module.exports = __webpack_public_path__ + "media/images/icons/country_flags/cv-aa02126ce32724f97a9cfb1067461f83.svg";